import React, { useEffect, useState } from "react";
import ChatbotButton from "./ChatbotButton";
import ChatbotOverlay from "./ChatbotOverlay";
import "./chat.css";

const Chatbot = ({
  chatbotId = "",
  userId = "",
  domain = "https://jaano.ai",
  reranking = true,
  queryexpansion = false,
  position = "bottomRight",
  color = "#000000",
}) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const toggleChat = () => setIsChatOpen(!isChatOpen);

  const iframeSrc = `${domain}/chatapp/${userId}/${chatbotId}/${reranking}/${queryexpansion}`;

  useEffect(() => {
    if (!chatbotId || !userId) {
      console.error("Chatbot configuration is incomplete.");
    }
  }, [chatbotId, userId]);

  if (!chatbotId || !userId) return null;

  return (
    <>
      <ChatbotButton onClick={toggleChat} color={color} position={position} />
      {isChatOpen && (
        <ChatbotOverlay onClose={toggleChat} iframeSrc={iframeSrc} />
      )}
    </>
  );
};

export default Chatbot;
